export const truncateEmail = (email: string, maxLength: number = 20) => {
    const parts = email.split('@')
    const domain = parts.length > 1 ? parts.pop() : ''
    const local = parts.join('@')
    const outputlocal =
        local.length > maxLength ? `${local.slice(0, maxLength)}...` : local
    const outputDomain = domain?.length ? `@${domain}` : ''
    return `${outputlocal}${outputDomain}`
}
